import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { NotableGenerationProperties } from "onboarding/llm-analytics/_snippets/notable-generation-properties.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OnboardingContentWrapper mdxType="OnboardingContentWrapper">
    <NotableGenerationProperties mdxType="NotableGenerationProperties" />
    </OnboardingContentWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      